module.exports = __webpack_public_path__ + "img/wetterspitze.37fe00e2.jpg";